'use client';

import { type ComponentProps, useState } from 'react';
import Link from 'next/link';

// Warm the complete destination when someone is about to follow it. Keeping
// untouched links cold avoids downloading every navigation target at startup.
export default function IntentLink({ href, onMouseEnter, onFocus, onTouchStart, ...props }: Omit<ComponentProps<typeof Link>, 'prefetch'>) {
  const [readyHref, setReadyHref] = useState<typeof href>();
  return (
    <Link
      {...props}
      href={href}
      prefetch={readyHref === href}
      onMouseEnter={(event) => {
        onMouseEnter?.(event);
        if (!event.defaultPrevented) setReadyHref(href);
      }}
      onFocus={(event) => {
        onFocus?.(event);
        if (!event.defaultPrevented) setReadyHref(href);
      }}
      onTouchStart={(event) => {
        onTouchStart?.(event);
        if (!event.defaultPrevented) setReadyHref(href);
      }}
    />
  );
}
